import { IJsonSerializable } from "../util/interfaces";
import { TypeHelper } from "../../helpers/type-helper";

export class OpDBScriptTable implements IJsonSerializable {

    // Members

    public name: string
    public headers: string[]
    public rows: any[][]

    // Members End

    // Cotr

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // Ctor End

    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || TypeHelper.isJSONCompressed(opObj)) {
                this.name = opObj.N
                this.headers = opObj.H
                this.rows = opObj.R
            } else {
                this.name = opObj.Name
                this.headers = opObj.Headers
                this.rows = opObj.Rows
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const result: any = {
                N: this.name,
                H: this.headers,
                R: this.rows
            }
            TypeHelper.setJSONCompressedFlag(result)
            TypeHelper.deleteNulls(result)

            return result
        }
        return {
            Name: this.name,
            Headers: this.headers,
            Rows: this.rows,
        }
    }

    // IJsonSerializable Implementation End 

}